module.exports = __webpack_public_path__ + "media/images/portal-logo-13113cc486dbac14689b3556b9a0d72c.svg";